module.exports = __webpack_public_path__ + "img/noticia-27B.32b4f0b7.jpg";